module.exports = __webpack_public_path__ + "img/l.0314848a.webp";